import React, { useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { Navbar } from "../../../components/Navbar/Navbar";
import { Footer } from "../../../components/Footer/Footer";
import { Banner } from "../../../components/Banner/Banner";
import topImage from "../../../assets/images/BannerTop.png";
import "./recreation.css"; // 스타일 파일 필요

export const Recreation = () => {
    const BOARD_URL = process.env.REACT_APP_BOARD_API_URL || 'http://localhost:5001';
    const [recreation, setRecreation] = useState(null); // 레크 데이터
    const [isAdmin, setIsAdmin] = useState(false);
    const navigate = useNavigate();

    useEffect(() => {
        // 1. 관리자 체크
        const token = localStorage.getItem("token");
        if (token) setIsAdmin(true);

        // 2. 최신 레크 가져오기
        const fetchRecreation = async () => {
            try {
                const res = await fetch(`${BOARD_URL}/recreations/latest`);
                const data = await res.json();
                if (data) setRecreation(data);
            } catch (err) {
                console.error("활동 로드 실패:", err);
            }
        };
        fetchRecreation();
    }, [BOARD_URL]);

    // 삭제 핸들러
    const handleDelete = async () => {
        if (!window.confirm("현재 활동을 삭제하시겠습니까?")) return;
        try {
            const token = localStorage.getItem("token");
            const res = await fetch(`${BOARD_URL}/recreations/${recreation._id}`, {
                method: 'DELETE',
                headers: { 'Authorization': `Bearer ${token}` }
            });
            if (res.ok) {
                alert("삭제되었습니다.");
                setRecreation(null); // 화면에서 즉시 제거
            }
        } catch (err) {
            alert("오류 발생");
        }
    };

    return(
        <>
            <Navbar />
            <Banner imageSrc={topImage} title="신체·인지 프로그램" />
            
            <div className="page" style={{ padding: '50px 20px', textAlign: 'center' }}>
                
                {/* 관리자용 버튼 영역 */}
                {isAdmin && (
                    <div className="admin-controls" style={{ marginBottom: '20px', display: 'flex', justifyContent: 'flex-end', gap: '10px', maxWidth: '800px', margin: '0 auto 20px' }}>
                        <Link to="/recreation/RecreationWrite">
                            <button style={{ padding: '8px 15px', backgroundColor: '#898989', color: 'white', border: 'none', borderRadius: '4px', cursor: 'pointer' }}>
                                새 활동 등록
                            </button>
                        </Link>
                        {recreation && (
                            <button onClick={handleDelete} style={{ padding: '8px 15px', backgroundColor: '#ff6b6b', color: 'white', border: 'none', borderRadius: '4px', cursor: 'pointer' }}>
                                삭제
                            </button>
                        )}
                    </div>
                )}

                {/* 식단표 보여주는 영역 */}
                {recreation ? (
                    <div className="recreation-content">
                        <header className="month" style={{ marginBottom: '20px' }}>
                            <div className="month-text" style={{ fontSize: '2rem', fontWeight: 'bold', color: '#333' }}>
                                {recreation.month}
                            </div>
                        </header>
                        <div className="top-title-line" style={{ maxWidth: '800px', margin: '0 auto' }}>
                            <img 
                                src={recreation.imageUrl} 
                                alt="식단표 이미지" 
                                style={{ width: '100%', borderRadius: '10px', boxShadow: '0 4px 10px rgba(0,0,0,0.1)' }}
                            />
                        </div>
                    </div>
                ) : (
                    // 등록된 식단표가 없을 때
                    <div style={{ padding: '100px 0', color: '#888' }}>
                        <h3>등록된 신체·인지 프로그램이 없습니다.</h3>
                        {isAdmin && <p>관리자님, 새 활동을 등록해주세요.</p>}
                    </div>
                )}
            </div>
            
            <Footer />
        </>
    );
}